// extracted by mini-css-extract-plugin
export default {"tiles":"MobileGroupSheet_tiles__LlJH0"};